export class CartItem {
	item_quantity?: number // Number of people - format integer ->> Example : 2
	item_PrestIds?: string[] // prestId selected - format string ->> Example : ??
	item_PrestNames?: string[] // prestName selected - format string - format string ->> Example : 3 pièces 4/6 personnes
	item_price_ati?: number // Item price all taxes included - format string
	item_begin_date?: string // Same value but could be updated on the product page - format string ->> Example : "28/06/2023"
	item_end_date?: string // Same value but could be updated on the product page - format string ->> Example : "14/07/2023"
	item_duration?: string // Same value but could be updated on the product page - format string ->> Example : "6 days"
	item_LiheId?: string
	item_LiheName?: string
	page_category1?: string // 1st level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: Alpes du Nord
	page_category2?: string // 2nd level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: Espace Haute Maurienne Vanoise
	page_category3?: string // 3rd level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: Location La Norma
	page_category4?: string // 4th level of product category (which is displayed in the breadcrumb) - format string ->> Example ?: If exists ?
	pageName?: string
	constructor(
		item_quantity?: number,
		item_PrestIds?: string[],
		item_PrestNames?: string[],
		item_price_ati?: number,
		item_begin_date?: string,
		item_end_date?: string,
		item_duration?: string,
		item_LiheId?: string,
		item_LiheName?: string,
		page_category1?: string,
		page_category2?: string,
		page_category3?: string,
		page_category4?: string,
		pageName?: string
	) {
		this.item_quantity = item_quantity
		this.item_PrestIds = item_PrestIds
		this.item_PrestNames = item_PrestNames
		this.item_price_ati = item_price_ati
		this.item_begin_date = item_begin_date
		this.item_end_date = item_end_date
		this.item_duration = item_duration
		this.item_LiheId = item_LiheId
		this.item_LiheName = item_LiheName
		this.page_category1 = page_category1
		this.page_category2 = page_category2
		this.page_category3 = page_category3
		this.page_category4 = page_category4
		this.pageName = pageName
	}

	public checkIsValid() {
		if (typeof this.item_quantity === "undefined")
			throw new Error("item_quantity is mandatory in CartItem")
		if (typeof this.item_PrestIds === "undefined")
			throw new Error("item_PrestIds is mandatory in CartItem")
		if (typeof this.item_PrestNames === "undefined")
			throw new Error("item_PrestNames is mandatory in CartItem")
		if (typeof this.item_price_ati === "undefined")
			throw new Error("item_price_ati is mandatory in CartItem")
		if (typeof this.item_begin_date === "undefined")
			throw new Error("item_begin_date is mandatory in CartItem")
		if (typeof this.item_end_date === "undefined")
			throw new Error("item_end_date is mandatory in CartItem")
		if (typeof this.item_duration === "undefined")
			throw new Error("item_duration is mandatory in CartItem")
		if (typeof this.item_LiheId === "undefined")
			throw new Error("item_LiheId is mandatory in CartItem")
		if (typeof this.item_LiheName === "undefined")
			throw new Error("item_LiheName is mandatory in CartItem")
		if (typeof this.page_category1 === "undefined")
			throw new Error("page_category1 is mandatory in CartItem")
		if (typeof this.page_category2 === "undefined")
			throw new Error("page_category2 is mandatory in CartItem")
		if (typeof this.page_category3 === "undefined")
			throw new Error("page_category3 is mandatory in CartItem")
		if (typeof this.page_category4 === "undefined")
			throw new Error("page_category4 is mandatory in CartItem")
	}
}
